import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-4 flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "grid gap-3 md:grid-cols-4"
};
const _hoisted_3 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_4 = {
  class: "mt-1 text-xl font-semibold text-slate-900"
};
const _hoisted_5 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_6 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_7 = {
  class: "data-table-shell border-none shadow-none"
};
const _hoisted_8 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_9 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_10 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_11 = {
  key: 1,
  class: "data-table-row"
};
const _hoisted_12 = {
  class: "data-table-td min-w-[240px]"
};
const _hoisted_13 = {
  class: "data-table-cell-title"
};
const _hoisted_14 = {
  class: "data-table-cell-meta"
};
const _hoisted_15 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_16 = {
  class: "text-slate-900"
};
const _hoisted_17 = {
  class: "text-xs text-slate-500"
};
const _hoisted_18 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_19 = {
  class: "data-table-td whitespace-nowrap font-mono text-xs text-slate-600"
};
const _hoisted_20 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_21 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_22 = {
  class: "data-table-td whitespace-nowrap text-slate-600"
};
const _hoisted_23 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_24 = {
  class: "flex flex-wrap items-center justify-center gap-1"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_35 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_36 = {
  class: "mt-4 grid grid-cols-2 gap-3 text-sm"
};
const _hoisted_37 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_38 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_39 = {
  class: "mt-1 font-mono text-xs"
};
const _hoisted_40 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_41 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_42 = {
  class: "mt-3 space-y-2"
};
const _hoisted_43 = {
  class: "flex items-center justify-between gap-3"
};
const _hoisted_44 = {
  class: "font-medium text-slate-900"
};
const _hoisted_45 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_46 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_47 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_48 = {
  class: "flex items-center justify-between"
};
const _hoisted_49 = {
  class: "mt-3 space-y-2"
};
const _hoisted_50 = {
  class: "font-medium text-slate-900"
};
const _hoisted_51 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_52 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_53 = ["disabled"];
const _hoisted_54 = {
  class: "space-y-4"
};
const _hoisted_55 = ["placeholder"];
const _hoisted_56 = {
  key: 2,
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_57 = {
  key: 3,
  class: "space-y-3"
};
const _hoisted_58 = ["onUpdate:modelValue"];
const _hoisted_59 = ["onUpdate:modelValue"];
const _hoisted_60 = ["onUpdate:modelValue"];
const _hoisted_61 = ["onUpdate:modelValue"];
const _hoisted_62 = ["onClick"];
const _hoisted_63 = ["disabled"];
const _hoisted_64 = {
  class: "data-table-shell"
};
const _hoisted_65 = {
  class: "data-table-scroll"
};
const _hoisted_66 = {
  class: "data-table text-sm"
};
const _hoisted_67 = {
  class: "data-table-td"
};
const _hoisted_68 = {
  class: "data-table-td"
};
const _hoisted_69 = {
  class: "data-table-td is-center"
};
const _hoisted_70 = ["href"];
const _hoisted_71 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_72 = {
  key: 0
};
import { computed, onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { archiveEsignFlow, cancelEsignFlow, createEsignFlow, forwardEsignFlow, getEsignFlowDetail, getEsignFlowFiles, getEsignFlowPage, modifyEsignFlowDeadline, releaseEsignFlow, remindEsignFlow, supplementEsignApprovers, syncEsignFlow, syncEsignFlowComponents } from '@/api/esign';
import { archiveStatusText, blank, flowStatusClass, flowStatusText, formatDateTime, normalizePage, partyStatusText, readArray, statusClassByResult } from './esign-utils';
export default {
  __name: 'EsignFlowManagement',
  setup(__props) {
    const loading = ref(false);
    const submitting = ref(false);
    const list = ref([]);
    const detail = ref(null);
    const currentFlow = ref(null);
    const files = ref([]);
    const detailVisible = ref(false);
    const createVisible = ref(false);
    const operationVisible = ref(false);
    const filesVisible = ref(false);
    const operationType = ref('');
    const filters = reactive({
      keyword: '',
      bizType: '',
      flowStatus: '',
      archiveStatus: ''
    });
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const createForm = reactive({
      flowName: '',
      templateId: '',
      bizType: '',
      bizId: '',
      bizNo: '',
      expireTime: '',
      userData: ''
    });
    const operationForm = reactive({
      expireTime: '',
      reason: '',
      recipientId: '',
      targetName: '',
      targetMobile: ''
    });
    const approverRows = ref([]);
    const flowStatusOptions = [{
      value: 'CREATING',
      label: '创建中'
    }, {
      value: 'SIGNING',
      label: '签署中'
    }, {
      value: 'PARTIALLY_SIGNED',
      label: '部分签署'
    }, {
      value: 'COMPLETED',
      label: '已完成'
    }, {
      value: 'REJECTED',
      label: '已拒签'
    }, {
      value: 'CANCELED',
      label: '已撤回'
    }, {
      value: 'EXPIRED',
      label: '已过期'
    }, {
      value: 'RELIEVED',
      label: '已解除'
    }, {
      value: 'EXCEPTION',
      label: '异常'
    }, {
      value: 'INVALID',
      label: '已失效'
    }];
    const detailParties = computed(() => readArray(detail.value?.parties || detail.value?.partyList));
    const detailFiles = computed(() => readArray(detail.value?.files || detail.value?.fileList));
    const summaryCards = computed(() => [{
      label: '签署中',
      value: list.value.filter(item => ['CREATING', 'SIGNING'].includes(item.flowStatus || item.status)).length
    }, {
      label: '部分签署',
      value: list.value.filter(item => (item.flowStatus || item.status) === 'PARTIALLY_SIGNED').length
    }, {
      label: '已完成',
      value: list.value.filter(item => (item.flowStatus || item.status) === 'COMPLETED').length
    }, {
      label: '异常/失败',
      value: list.value.filter(item => ['EXCEPTION', 'SYNC_FAILED', 'REJECTED'].includes(item.flowStatus || item.status)).length
    }]);
    const operationTitle = computed(() => ({
      deadline: '修改截止时间',
      remind: '发送催办',
      release: '发起解除协议',
      approvers: '补充签署方',
      forward: '转他人处理',
      cancel: '取消流程'
    })[operationType.value] || '流程操作');
    const operationPlaceholder = computed(() => ({
      remind: '填写催办消息，可为空',
      release: '请填写解除原因',
      cancel: '请填写取消原因'
    })[operationType.value] || '请输入原因');
    const fetchList = async () => {
      loading.value = true;
      try {
        const res = await getEsignFlowPage({
          current: pagination.value.current,
          size: pagination.value.size,
          ...filters
        });
        const page = normalizePage(res, pagination.value);
        list.value = page.records;
        pagination.value = page.pagination;
      } catch (error) {
        ElMessage.error(error.message || '加载签署流程失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchList();
    };
    const handleReset = () => {
      Object.assign(filters, {
        keyword: '',
        bizType: '',
        flowStatus: '',
        archiveStatus: ''
      });
      handleSearch();
    };
    const handlePageChange = page => {
      pagination.value.current = page;
      fetchList();
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    };
    const openCreate = () => {
      Object.assign(createForm, {
        flowName: '',
        templateId: '',
        bizType: '',
        bizId: '',
        bizNo: '',
        expireTime: '',
        userData: ''
      });
      createVisible.value = true;
    };
    const submitCreate = async () => {
      if (!createForm.flowName || !createForm.templateId) {
        ElMessage.warning('请填写流程名称和模板 ID');
        return;
      }
      submitting.value = true;
      try {
        await createEsignFlow({
          ...createForm
        });
        ElMessage.success('签署流程已发起');
        createVisible.value = false;
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '发起流程失败');
      } finally {
        submitting.value = false;
      }
    };
    const openDetail = async item => {
      detailVisible.value = true;
      detail.value = null;
      try {
        detail.value = await getEsignFlowDetail(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载流程详情失败');
      }
    };
    const runSimpleAction = async (item, type) => {
      const actionMap = {
        sync: ['同步流程状态', () => syncEsignFlow(item.id), '同步已完成'],
        components: ['同步填写控件', () => syncEsignFlowComponents(item.id), '控件同步已完成'],
        archive: ['触发流程归档', () => archiveEsignFlow(item.id), '归档任务已提交']
      };
      const [title, action, message] = actionMap[type];
      await ElMessageBox.confirm(`确认${title}「${item.flowName || item.flowNo || item.id}」吗？`, title, {
        type: 'warning'
      });
      try {
        await action();
        ElMessage.success(message);
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || `${title}失败`);
      }
    };
    const openOperation = (item, type) => {
      currentFlow.value = item;
      operationType.value = type;
      Object.assign(operationForm, {
        expireTime: item.expireTime || '',
        reason: '',
        recipientId: '',
        targetName: '',
        targetMobile: ''
      });
      approverRows.value = [];
      if (type === 'approvers') addApprover();
      operationVisible.value = true;
    };
    const addApprover = () => approverRows.value.push({
      key: `${Date.now()}-${Math.random()}`,
      roleCode: '',
      name: '',
      mobile: '',
      organizationName: ''
    });
    const submitOperation = async () => {
      submitting.value = true;
      try {
        const id = currentFlow.value.id;
        if (operationType.value === 'deadline') await modifyEsignFlowDeadline(id, {
          expireTime: operationForm.expireTime
        });
        if (operationType.value === 'remind') await remindEsignFlow(id, {
          message: operationForm.reason
        });
        if (operationType.value === 'release') await releaseEsignFlow(id, {
          reason: operationForm.reason
        });
        if (operationType.value === 'cancel') await cancelEsignFlow(id, {
          reason: operationForm.reason
        });
        if (operationType.value === 'forward') await forwardEsignFlow(id, {
          ...operationForm
        });
        if (operationType.value === 'approvers') {
          const approvers = approverRows.value.map(item => {
            const row = {
              ...item
            };
            delete row.key;
            return row;
          }).filter(row => row.roleCode || row.mobile || row.name);
          await supplementEsignApprovers(id, {
            approvers
          });
        }
        ElMessage.success('流程操作已提交');
        operationVisible.value = false;
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '流程操作失败');
      } finally {
        submitting.value = false;
      }
    };
    const openFiles = async item => {
      filesVisible.value = true;
      files.value = [];
      try {
        const res = await getEsignFlowFiles(item.id);
        files.value = readArray(res);
      } catch (error) {
        ElMessage.error(error.message || '加载流程文件失败');
      }
    };
    onMounted(fetchList);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between"
        }, [_cache[25] || (_cache[25] = _createElementVNode("div", null, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "签署流程"), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, "发起、跟踪和处理腾讯电子签流程，支持同步、催办、延期、解除、补充签署方和归档。")], -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-primary inline-flex items-center gap-2",
          onClick: openCreate
        }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 发起流程 ", -1)]))])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm"
          }, [_createElementVNode("p", _hoisted_3, _toDisplayString(item.label), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(item.value), 1)]);
        }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            class: "form-search-input form-control-sm w-full",
            placeholder: "搜索流程号、名称或业务编号",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, filters.keyword]]), _cache[26] || (_cache[26] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.bizType = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "业务类型"
          }, null, 512), [[_vModelText, filters.bizType]]), _createVNode(_component_el_select, {
            modelValue: filters.flowStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.flowStatus = $event),
            placeholder: "请选择流程状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部流程状态",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(flowStatusOptions, option => {
              return _createVNode(_component_el_option, {
                key: option.value,
                label: option.label,
                value: option.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.archiveStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.archiveStatus = $event),
            placeholder: "请选择归档状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部归档状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "未归档",
              value: "NONE"
            }), _createVNode(_component_el_option, {
              label: "待归档",
              value: "PENDING"
            }), _createVNode(_component_el_option, {
              label: "归档中",
              value: "ARCHIVING"
            }), _createVNode(_component_el_option, {
              label: "已归档",
              value: "SUCCESS"
            }), _createVNode(_component_el_option, {
              label: "归档失败",
              value: "FAILED"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[29] || (_cache[29] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "流程"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "业务"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "模板"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "腾讯 FlowId"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "归档"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "截止时间"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[27] || (_cache[27] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "正在加载流程...", -1)]))])) : !list.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[28] || (_cache[28] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无签署流程", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.flowName || item.subject || '-'), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.flowNo || item.id), 1)]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.bizType || '-'), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(item.bizNo || item.bizId || '-'), 1)]), _createElementVNode("td", _hoisted_18, _toDisplayString(item.templateName || item.templateCode || item.templateId || '-'), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(blank)(item.tencentFlowId)), 1), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', _unref(flowStatusClass)(item.flowStatus || item.status)])
          }, _toDisplayString(_unref(flowStatusText)(item.flowStatus || item.status)), 3)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', _unref(statusClassByResult)(item.archiveStatus)])
          }, _toDisplayString(_unref(archiveStatusText)(item.archiveStatus)), 3)]), _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatDateTime)(item.expireTime) || '-'), 1), _createElementVNode("td", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            onClick: $event => openDetail(item)
          }, "详情", 8, _hoisted_25), _createElementVNode("button", {
            class: "table-action-button is-success",
            onClick: $event => runSimpleAction(item, 'sync')
          }, "同步", 8, _hoisted_26), _createElementVNode("button", {
            class: "table-action-button is-teal",
            onClick: $event => runSimpleAction(item, 'components')
          }, "控件", 8, _hoisted_27), _createElementVNode("button", {
            class: "table-action-button is-indigo",
            onClick: $event => openOperation(item, 'deadline')
          }, "延期", 8, _hoisted_28), _createElementVNode("button", {
            class: "table-action-button",
            onClick: $event => openOperation(item, 'remind')
          }, "催办", 8, _hoisted_29), _createElementVNode("button", {
            class: "table-action-button",
            onClick: $event => openOperation(item, 'approvers')
          }, "补签署方", 8, _hoisted_30), _createElementVNode("button", {
            class: "table-action-button",
            onClick: $event => openOperation(item, 'forward')
          }, "转他人", 8, _hoisted_31), _createElementVNode("button", {
            class: "table-action-button is-purple",
            onClick: $event => runSimpleAction(item, 'archive')
          }, "归档", 8, _hoisted_32), _createElementVNode("button", {
            class: "table-action-button is-danger",
            onClick: $event => openOperation(item, 'cancel')
          }, "取消", 8, _hoisted_33)])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])])]), _createVNode(_component_el_drawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => detailVisible.value = $event),
          title: "流程详情",
          size: "760px"
        }, {
          default: _withCtx(() => [detail.value ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("section", _hoisted_35, [_cache[34] || (_cache[34] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "基础信息", -1)), _createElementVNode("dl", _hoisted_36, [_createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "流程名称", -1)), _createElementVNode("dd", _hoisted_37, _toDisplayString(detail.value.flowName || detail.value.subject || '-'), 1)]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "流程号", -1)), _createElementVNode("dd", _hoisted_38, _toDisplayString(detail.value.flowNo || detail.value.id), 1)]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "腾讯 FlowId", -1)), _createElementVNode("dd", _hoisted_39, _toDisplayString(_unref(blank)(detail.value.tencentFlowId)), 1)]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "失败原因", -1)), _createElementVNode("dd", _hoisted_40, _toDisplayString(_unref(blank)(detail.value.failReason)), 1)])])]), _createElementVNode("section", _hoisted_41, [_cache[35] || (_cache[35] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "签署方", -1)), _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailParties.value, party => {
            return _openBlock(), _createElementBlock("div", {
              key: party.id || party.tencentRecipientId,
              class: "rounded-xl bg-slate-50 p-3 text-sm"
            }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(party.roleName || party.personName || party.organizationName || '-'), 1), _createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(statusClassByResult)(party.partyStatus || party.status)])
            }, _toDisplayString(_unref(partyStatusText)(party.partyStatus || party.status)), 3)]), _createElementVNode("div", _hoisted_45, _toDisplayString(party.personMobile || '-') + " / RecipientId: " + _toDisplayString(party.tencentRecipientId || '-'), 1)]);
          }), 128)), !detailParties.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_46, "暂无签署方信息")) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_cache[36] || (_cache[36] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "流程文件", -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[4] || (_cache[4] = $event => openFiles(detail.value))
          }, "查看文件")]), _createElementVNode("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailFiles.value, file => {
            return _openBlock(), _createElementBlock("div", {
              key: file.id || file.tencentFileId,
              class: "rounded-xl bg-slate-50 p-3 text-sm"
            }, [_createElementVNode("div", _hoisted_50, _toDisplayString(file.fileName || file.name || '-'), 1), _createElementVNode("div", _hoisted_51, "TencentFileId: " + _toDisplayString(file.tencentFileId || '-'), 1)]);
          }), 128)), !detailFiles.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_52, "暂无文件信息")) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: createVisible.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => createVisible.value = $event),
          title: "发起签署流程",
          width: "720px"
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: _cache[13] || (_cache[13] = $event => createVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary ml-2",
            type: "button",
            disabled: submitting.value,
            onClick: submitCreate
          }, "发起", 8, _hoisted_53)]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "120px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "流程名称",
              required: ""
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => createForm.flowName = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.flowName]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "模板 ID",
              required: ""
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => createForm.templateId = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.templateId]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "业务类型"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => createForm.bizType = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.bizType]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "业务 ID"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => createForm.bizId = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.bizId]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "业务编号"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => createForm.bizNo = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.bizNo]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "截止时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: createForm.expireTime,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => createForm.expireTime = $event),
                class: "form-date w-full",
                type: "datetime",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "UserData"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => createForm.userData = $event),
                class: "form-textarea w-full",
                rows: "3",
                placeholder: "可选，业务透传信息"
              }, null, 512), [[_vModelText, createForm.userData]])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: operationVisible.value,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => operationVisible.value = $event),
          title: operationTitle.value,
          width: "720px"
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: _cache[21] || (_cache[21] = $event => operationVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary ml-2",
            type: "button",
            disabled: submitting.value,
            onClick: submitOperation
          }, "确认", 8, _hoisted_63)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [operationType.value === 'deadline' ? (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 0,
            modelValue: operationForm.expireTime,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => operationForm.expireTime = $event),
            class: "form-date w-full",
            type: "datetime",
            "value-format": "YYYY-MM-DD HH:mm:ss"
          }, null, 8, ["modelValue"])) : _createCommentVNode("", true), ['remind', 'release', 'cancel'].includes(operationType.value) ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => operationForm.reason = $event),
            class: "form-textarea w-full",
            rows: "4",
            placeholder: operationPlaceholder.value
          }, null, 8, _hoisted_55)), [[_vModelText, operationForm.reason]]) : _createCommentVNode("", true), operationType.value === 'forward' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => operationForm.recipientId = $event),
            class: "form-input",
            placeholder: "原 RecipientId"
          }, null, 512), [[_vModelText, operationForm.recipientId]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => operationForm.targetName = $event),
            class: "form-input",
            placeholder: "接收人姓名"
          }, null, 512), [[_vModelText, operationForm.targetName]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => operationForm.targetMobile = $event),
            class: "form-input",
            placeholder: "接收人手机号"
          }, null, 512), [[_vModelText, operationForm.targetMobile]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => operationForm.reason = $event),
            class: "form-input",
            placeholder: "转交原因"
          }, null, 512), [[_vModelText, operationForm.reason]])])) : _createCommentVNode("", true), operationType.value === 'approvers' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(approverRows.value, (approver, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: approver.key,
              class: "grid gap-3 rounded-2xl border border-slate-200 p-3 md:grid-cols-5"
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => approver.roleCode = $event,
              class: "form-input",
              placeholder: "角色编码"
            }, null, 8, _hoisted_58), [[_vModelText, approver.roleCode]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => approver.name = $event,
              class: "form-input",
              placeholder: "姓名/企业名"
            }, null, 8, _hoisted_59), [[_vModelText, approver.name]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => approver.mobile = $event,
              class: "form-input",
              placeholder: "手机号"
            }, null, 8, _hoisted_60), [[_vModelText, approver.mobile]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => approver.organizationName = $event,
              class: "form-input",
              placeholder: "企业名称"
            }, null, 8, _hoisted_61), [[_vModelText, approver.organizationName]]), _createElementVNode("button", {
              type: "button",
              class: "btn-danger-secondary",
              onClick: $event => approverRows.value.splice(index, 1)
            }, "删除", 8, _hoisted_62)]);
          }), 128)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: addApprover
          }, "添加签署方")])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
          modelValue: filesVisible.value,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => filesVisible.value = $event),
          title: "流程文件",
          width: "820px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("table", _hoisted_66, [_cache[38] || (_cache[38] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "文件名"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "归档状态"), _createElementVNode("th", {
            class: "data-table-th is-center"
          }, "操作")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, file => {
            return _openBlock(), _createElementBlock("tr", {
              key: file.id || file.fileUrl,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_67, _toDisplayString(file.fileName || file.name || '-'), 1), _createElementVNode("td", _hoisted_68, [_createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(statusClassByResult)(file.archiveStatus || file.tencentUploadStatus)])
            }, _toDisplayString(_unref(archiveStatusText)(file.archiveStatus) || file.tencentUploadStatus || '-'), 3)]), _createElementVNode("td", _hoisted_69, [file.archiveFileUrl || file.signedFileUrl || file.fileUrl ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "table-action-button is-primary",
              href: file.archiveFileUrl || file.signedFileUrl || file.fileUrl,
              target: "_blank",
              rel: "noreferrer"
            }, "打开", 8, _hoisted_70)) : (_openBlock(), _createElementBlock("span", _hoisted_71, "无链接"))])]);
          }), 128)), !files.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [...(_cache[37] || (_cache[37] = [_createElementVNode("td", {
            colspan: "3",
            class: "data-table-empty"
          }, "暂无文件", -1)]))])) : _createCommentVNode("", true)])])])])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};